import React, { Component } from 'react';
import AccountSidebar from './AccountSidebar';
import Header from '../../../Common/Component/Header';
import Sidebar from '../../../Common/Component/Sidebar';
// Components
import ExpiredCard from './ExpiredCard';
import SalesByItem from './SalesByItem';
import SalesTax from './SalesTax/SalesTax';
import WorkOrders from './WorkOrders';
import PaymentHistory from './PaymentHistory';
import MonthlyForecast from './MonthlyForecast';
import ViewEditInvoice from './ViewEditInvoice';
import AddNewInvoice from '../../../ResidentialManagement/CustomerDetail/Component/Service/Invoices/AddNewInvoice';
import AddNewInvoiceNew from '../../../CommercialManagement/CustomerDetail/Component/Service/Invoices/AddNewInvoiceNew';
import AccountListTable from './AccountListTable';
import AccountAgingSummary from './AccountAgingSummary';
import moment from 'moment-timezone';
class AccountList extends Component {
  state = {
    current: 0,
    curr_id: '',
    is_crud_allow : true,
    service_order_uuid : '',
    current_invoice_uuid: '',
    is_disable_franchise : false,
    user_uuid: '',
    date: '',
    customerType:'',
    customer: {},
    ComCustomer:{},
    customerId:'',
    selectedData:'',
    selectedBatchOption:''
  }

  componentDidMount = () => {
    // this.props.getCustomers({ limit: 10, offset: 0 });
    const user = JSON.parse(localStorage.getItem("authUser"));
    if ((user?.user?.role.includes("business_dev_franchiese") || user?.user?.role.includes("operations_mgr") || user?.user?.role.includes("service_rep"))) {
      this.setState({
        is_crud_allow: false
      })
    }
    if (user?.user?.role.includes(`business_dev_franchiese`) || user?.user?.role.includes(`accounting_franchiese`) || user?.user?.role.includes(`operations_mgr`)) {
      this.setState({ is_disable_franchise: true })
    }

    // Esha Singh
    const { history } = this.props;
    const current = history?.location?.state?.query?.current;
    if (current) this.setState({current})
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    // get customer detail
    if (Object.keys(nextProps?.CustomerList?.customer).length > 0) { 
      this.setState({ customer: nextProps?.CustomerList?.customer });
    }
    
    // get customer detail
    if (Object.keys(nextProps?.CommercialCustomer?.getCustomer).length > 0) { 
      this.setState({ ComCustomer: nextProps?.CommercialCustomer?.getCustomer });
    }
  }

  //Reder Step
  RenderAllStep = () => {
    let {
      current,
      current_invoice_uuid,
      service_order_uuid,
      is_crud_allow,
      is_disable_franchise,
      user_uuid,
      date,customerType
    } = this.state;
    
    switch (current) {
    case 0:
      return <AccountListTable 
        {...this.props} 
        customerType={this.state.customerType} 
        ChangeComponent={this.ChangeComponent}  
        selectedBatch={this.selectedBatch}
        selectedBatchOption={this.state.selectedBatchOption}
        invoice_uuid={current_invoice_uuid} 
        viewInvoice={this.viewInvoice} 
        is_disable_franchise={is_disable_franchise} 
        is_crud_allow={is_crud_allow} 
        getCommercialCustomer={this.props.getCommercialCustomer}
        getCustomerDetail={this.props.getCustomerDetail}
        CustomerList={this.props.CustomerList}
        CommercialCustomer={this.props.CommercialCustomer}
        selectedRecord={this.selectedRecord}
      />
    case 1:
      return <ExpiredCard {...this.props} ChangeComponent={this.ChangeComponent} is_disable_franchise={is_disable_franchise} />
    case 2:
      return <SalesByItem {...this.props} ChangeComponent={this.ChangeComponent} is_disable_franchise={is_disable_franchise} />
    case 3:
      return <AccountAgingSummary {...this.props} ChangeComponent={this.ChangeComponent} is_disable_franchise={is_disable_franchise} />
    case 4:
      return <MonthlyForecast {...this.props} ChangeComponent={this.ChangeComponent} is_disable_franchise={is_disable_franchise}/>
    case 5:
      if(customerType==='commercial'){
        return <AddNewInvoiceNew
          onChangeView={this.ChangeComponent}
          customerId={this.state.customerId}
          customer={this.state.ComCustomer}
          invoice_uuid={current_invoice_uuid}
          service_order_uuid={service_order_uuid}
          // APIs
          getInvoiceList={this.getInvoiceList}
          getServiceOrderNumberList={this.props.getServiceOrderNumberList}
          addInvoice={this.props.addInvoice}
          addManualInvoice={this.props.addManualInvoice}
          getServiceOrderById={this.props.getServiceOrderById}
          addInvoiceLineItem={this.props.addInvoiceLineItem}
          deleteInvoice={this.props.deleteInvoice}
          resendInvoice={this.props.resendInvoice}
          finalizeInvoice={this.props.finalizeInvoice}
          getInvoiceDescription={this.props.getInvoiceDescription}
          getSalesTax={this.props.getSalesTax}
          getWorkOrderList={this.props.getWorkOrderList}
          getWorkOrderDetail={this.props.getWorkOrderDetail}
          getCommercialWorkOrder={this.props.getCommercialWorkOrder}
          getInvoiceById={this.props.getInvoiceById}
          invoiceProcess={this.props.invoiceProcess}
          //reducer
          Invoice={this.props.Invoice}
          ServiceOrder={this.props.ServiceOrder}
          InvoiceDescription={this.props.InvoiceDescription}
          workOrderList={this.props.workOrderList}
          WorkOrderDetail={this.props.WorkOrderDetail}
          CommercialWorkOrder={this.props.CommercialWorkOrder}
          InvoiceProcess={this.props.InvoiceProcess}
        />
      }else{
        return <AddNewInvoice
          accountList={true}
          invoice_uuid={current_invoice_uuid}
          service_order_uuid={service_order_uuid}
          onChangeView={this.ChangeComponent}
          customerId={this.state.customerId}
          customer={this.state.customer}

          // APIs
          getInvoiceList={this.getInvoiceList}
          getServiceOrderNumberList={this.props.getServiceOrderNumberList}
          addInvoice={this.props.addInvoice}
          addManualInvoice={this.props.addManualInvoice}
          getServiceOrderById={this.props.getServiceOrderById}
          addInvoiceLineItem={this.props.addInvoiceLineItem}
          deleteInvoice={this.props.deleteInvoice}
          resendInvoice={this.props.resendInvoice}
          finalizeInvoice={this.props.finalizeInvoice}
          getInvoiceDescription={this.props.getInvoiceDescription}
          getInvoiceById={this.props.getInvoiceById}
          getSalesTax={this.props.getSalesTax}
          getWorkOrderList={this.props.getWorkOrderList}
          getWorkOrderDetail={this.props.getWorkOrderDetail}
          invoiceProcess={this.props.invoiceProcess}
          //reducer
          Invoice={this.props.Invoice}
          ServiceOrder={this.props.ServiceOrder}
          InvoiceDescription={this.props.InvoiceDescription}
          workOrderList={this.props.workOrderList}
          WorkOrderDetail={this.props.WorkOrderDetail}
          InvoiceProcess={this.props.InvoiceProcess}
        />
      }
      // return <ViewEditInvoice {...this.props} ChangeComponent={this.ChangeComponent} current_invoice_uuid={current_invoice_uuid} service_order_uuid={service_order_uuid} is_crud_allow={is_crud_allow} user_uuid={user_uuid} />
    case 6:
      return <PaymentHistory selectedData={this.state.selectedData} current_invoice_uuid={current_invoice_uuid} {...this.props} ChangeComponent={this.ChangeComponent} />
    case 7:
      return <SalesTax current_invoice_uuid={current_invoice_uuid} {...this.props} ChangeComponent={this.ChangeComponent} is_disable_franchise={is_disable_franchise} is_crud_allow={is_crud_allow} />
    case 8:
      return <WorkOrders {...this.props} selectedBatch={this.selectedBatch} ChangeComponent={this.ChangeComponent} selectedRecord={this.selectedRecord} />
    default:
      return <AccountListTable {...this.props} customerType={this.state.customerType} ChangeComponent={this.ChangeComponent} />
    }
  }

  ChangeComponent = (e) => {
    this.setState({ current: e})
  }

  selectedBatch = (e) => {
    this.setState({selectedBatchOption:e})
  }

  selectedRecord = (e) =>{
    this.setState({selectedData:e})
  }

  //View invvoice ID set
  viewInvoice = (id,service_order_id, row) => {
    this.setState({
      current_invoice_uuid: id,
      service_order_uuid : service_order_id,
      user_uuid: row?.user_uuid,
      customerType:row?.service_order?.service_type,
      customerId:row?.user_uuid
    })
    if(row?.service_order?.service_type==='residential'){
      this.props.getCustomerDetail(row?.user_uuid) // get customer detail
    }else{
      this.props.getCommercialCustomer(row?.user_uuid)
    }
  }

  setData = (date) => {
    this.setState({
      date: date,
    }, () => {
      // console.warn("date", date)
    })
  }

  render() {
    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header
            hideSearch={true}
            placeholder="Invoice Number, Customer Name"
            disabled={true}
          />

          {/* Sidebar */}
          <Sidebar history={this.props.history} {...this.props} />
          <div className="container">
            <div className="aside-area pt-0 account_module_wrapper">
              {
                this.state.current !== 8 ?
                  <AccountSidebar 
                    {...this.props} 
                    ChangeComponent={this.ChangeComponent} 
                    setData={this.setData}
                  /> : null
              }
              <div className="main p-0">
                {this.RenderAllStep()}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AccountList;